const serverMaxTimes = 50;
const maxTerms = 100;

export function getServerTimeOptions() {
  const res = [];
  for (let idx = 0; idx < serverMaxTimes; idx++) {
    const val = idx + 1;
    res.push({ value: val, label: `${val}次` });
  }

  return res;
}

export function getTermsData(needAll = false) {
  const res = [];
  if (needAll) {
    res.push({ name: `全部`, id: 0 });
  }
  for (let idx = 1; idx <= maxTerms; idx++) {
    res.push({ name: `第${idx}期`, id: idx });
  }

  return res;
}

export function sortByChinese(data) {
  if (!data || !Array.isArray(data)) return data;

  return data.sort((a, b) => {
    if (!a || !b) return true;
    const nameA = a.name;
    const nameB = b.name;
    const arrA = nameA.split("");
    const arrB = nameB.split("");
    return arrA[0]?.toString().localeCompare(arrB[0]?.toString(), "zh");
  });
}
